import { SET_STORY_ELEMENTS } from 'client/constants/actions';
import { StoryVersionType } from 'types/story';

/**
 * @param payload {Object} Story elements array
 * @return {{type: *, payload: *}}
 */
export function setStoryElements(payload: StoryVersionType['data']['elements']) {
	return {
		type: SET_STORY_ELEMENTS,
		payload,
	};
}
